import { useEffect, useState } from 'react'
import cn from 'classnames'
import SnackbarIconClose from './snackbar.icon-close'
import { SnackbarProps } from './snackbaar.interface'
import './snackbar.style.scss'

export const Snackbar = (props: SnackbarProps) => {
  const {
    avatarSrc,
    avatarAlt,
    description,
    icon,
    onClose,
    position = 'bottom-left',
    show,
    textClose,
    title,
    timer = 5000,
    className,
    ...restProps
  } = props

  const [isShow, setIsShow] = useState(show)

  const classWrapper = cn(className, {
    'legion-snackbar': true,
    [`legion-snackbar--${position}`]: true,
  })

  useEffect(() => {
    setIsShow(show)
  }, [show])

  useEffect(() => {
    if (show) {
      const setTimer = setTimeout(() => {
        setIsShow(false)
        onClose?.()
      }, timer)

      return () => clearTimeout(setTimer)
    }
  })

  if (!isShow) return null

  return (
    <div {...restProps} role="presentation" className={classWrapper}>
      {icon || avatarSrc ? (
        <div className="legion-snackbar__images">
          {icon && <span className="legion-snackbar__image legion-snackbar__image--icon">{icon}</span>}
          {avatarSrc &&
          <img src={avatarSrc} alt={avatarAlt} className="legion-snackbar__image legion-snackbar__image--avatar"/>}
        </div>
      ) : null}
      <div className="legion-snackbar__content">
        {title && <h4 className="legion-snackbar__text legion-snackbar__text--title">{title}</h4>}
        {description && <p className="legion-snackbar__text legion-snackbar__text--description">{description}</p>}
      </div>
      <button className="legion-snackbar__close" onClick={onClose}>
        {textClose && textClose}
        <SnackbarIconClose/>
      </button>
    </div>
  )
}
